import TypographyCustom from '@material-ui/core/Typography/Typography'
import styled from 'styled-components'

const Typography = styled(TypographyCustom)``

export default Typography
